import { default as React, FC, memo } from 'react'
import cn from 'classnames'
import { IDetailsOrder } from '../../../types/orders'
import OrderStatus from '../../../orders/OrderStatus'
import Tooltip from '../../../components/Tooltip'

interface IOwnProps {
  order: IDetailsOrder
}

const TdStatus: FC<IOwnProps> = ({ order }) => {
  const hasShipments = !!order.orderTrackingStatuses.length

  if (order.status === 'submitted') {
    return (
      <div className="table_td -g20">
        <div
          className={cn('table_text -lines-2')}
          style={{ color: hasShipments ? '#3ABF77' : '#0061D2' }}
        >
          {hasShipments ? 'Shipped' : 'Submitted'}
        </div>
      </div>
    )
  }

  return (
    <div className="table_td -g20">
      <div
        className={cn('table_text status -lines-2', {
          '-success': order.status === 'approved',
          '-danger': order.status === 'rejected',
        })}
      >
        {(order.status !== 'rejected' || !order.rejectReason) && (
          <OrderStatus order={order} short />
        )}
        {order.status === 'rejected' && order.rejectReason && (
          <Tooltip id={`tooltip-updated-by-${order.id}`}>
            <div
              className="input_list-tooltip"
              data-tip={order.rejectReason}
              data-for={`tooltip-updated-by-${order.id}`}
              data-effect="solid"
              data-place="bottom"
            >
              {<OrderStatus order={order} short />}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default memo(TdStatus)
